import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { GridConfig, calculaAlturaGrid, adicionaIconesGrid } from './../app.config';
import { OrdemServico } from '../ordem-servico/ordem-servico.model';
import { NTECH_API } from '../app.api';
import { Router } from '@angular/router';
import CustomStore from 'devextreme/data/custom_store';
import { Http } from '@angular/http';
import { ServicoService } from '../servico/servico.service';
import { TecnicoService } from '../tecnico/tecnico.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { EquipeService } from '../equipe/equipe.service';
import notify from 'devextreme/ui/notify';
import { OrdemServicoService } from '../ordem-servico/ordem-servico.service';
import { listaEstadosAndamento } from '../shared/listas-parametros';

@Component({
  selector: 'ntc-ordens-servico',
  templateUrl: './ordens-servico.component.html',
  styleUrls: ['./ordens-servico.component.css']
})
export class OrdensServicoComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;
  listaForm = {Id: 'listaEquipe', status: false};

  listaEstadoAndamento = listaEstadosAndamento;

  listaOrdensServico: CustomStore;
  alturaGrid = null;

  listaServico = [];
  listaTecnico = [];
  listaEquipe = [];

  colunasGridOrdensServico = [];

/*
  colunasGridOrdensServico = [
    {
      dataField: 'Id',
      dataType: 'string',
      width: '125',
      caption: 'ID'
    },
    {
      dataField: 'DescricaoSolicitacao',
      dataType: 'string',
      caption: 'Descrição'
    },
    {
      dataField: 'DtHrCadastro',
      dataType: 'date',
      caption: 'Data de Cadastro'
    }
  ];
*/
  editOptionsGridOrdensServico = {
    mode: GridConfig.gridMode,
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true,
    popup: {
      title: 'Ordens de Servico',
      showTitle: true
    }
  };

  popupVisible = false;

  distribuirOSForm = {
    Id: 0,
    DescricaoSolicitacao: '',
    IdEquipe: null
  };

  itemsDistribuirOSForm = [];
  colCountByScreen = {
      'lg': 2,
      'md': 2,
      'sm': 1,
      'xs': 1
  };
  OSAux: OrdemServico = null;

  constructor(
    @Inject(Http) http: Http,
    private router: Router,
    private servicoService: ServicoService,
    private tecnicoService: TecnicoService,
    private equipeService: EquipeService,
    private ordemServicoService: OrdemServicoService
  ) {
    // carrega listas
    servicoService.getServicos().subscribe(servicos => {
      this.listaServico = servicos;
      // this.verificarListasCarregadas('listaServico');
    },
    error => {
      // this.verificarListasCarregadas('listaServico');
      notify('Erro ao carregar Serviços!', 'error', 2000);
    });

    tecnicoService.getTecnicos().subscribe(tecnicos => {
      this.listaTecnico = tecnicos;
      // this.verificarListasCarregadas('listaTecnico');
    },
    error => {
      // this.verificarListasCarregadas('listaTecnico');
      notify('Erro ao carregar Técnicos!', 'error', 2000);
    });

    equipeService.getEquipes().subscribe(equipes => {
      this.listaEquipe = equipes;
      this.verificarListasCarregadas('listaEquipe');
    },
    error => {
      notify('Erro ao carregar Equipes!', 'error', 2000);
    });

    // carrega dados das O.S.
    this.listaOrdensServico = new CustomStore({
      remove: function (key) {
        return http.delete(`${NTECH_API}/ordem-servico/${encodeURIComponent(key.Id)}`).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/ordem-servico/`)
            .toPromise()
            .then(responseOS => {
              // ----
              const retorno = responseOS.json();
              let axUltimoEstado = null;
              // pegar ultimo estado andamento
              if ( (retorno !== undefined ) && ( retorno.length !== undefined ) && (retorno.length > 0)  ) {
                for ( let i = 0 ; i < retorno.length ; i ++ ) {
                  // verificar se existe registros de estado andamento
                  if ( (retorno[i].OSEstados !== undefined) && ( retorno[i].OSEstados !== null ) &&
                  (retorno[i].OSEstados.length !== undefined) && (retorno[i].OSEstados.length > 0)
                  ) {
                    retorno[i].IdUltimoEstadoAndamento = 0;
                    axUltimoEstado = null;
                    for ( let j = 0 ; j < retorno[i].OSEstados.length ; j ++) {
                      if ( axUltimoEstado === null ) {
                        axUltimoEstado = {
                          IdEstadosAndamento: retorno[i].OSEstados[j].IdEstadosAndamento,
                          DtHrOSEstado: retorno[i].OSEstados[j].DtHrOSEstado
                        };
                        retorno[i].IdUltimoEstadoAndamento = retorno[i].OSEstados[j].IdEstadosAndamento;
                      } else if (
                        (new Date(retorno[i].OSEstados[j].DtHrOSEstado).getTime()) >= (new Date(axUltimoEstado.DtHrOSEstado).getTime())
                      ) {
                        axUltimoEstado = {
                          IdEstadosAndamento: retorno[i].OSEstados[j].IdEstadosAndamento,
                          DtHrOSEstado: retorno[i].OSEstados[j].DtHrOSEstado
                        };
                        retorno[i].IdUltimoEstadoAndamento = retorno[i].OSEstados[j].IdEstadosAndamento;
                      }
                    }
                    axUltimoEstado = null;
                  }
                }
              }
              return retorno;
            })
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });
  }

  verificarListasCarregadas(nomeLista: string): boolean {

    // altera o status da lista informada para true
    if (nomeLista !== '') {
      this.listaForm.status = true;
    }

    // verifica os status das listas para montar o form  e retirar o backdrop (loading)
    if (this.listaForm.status === true) {

      this.colunasGridOrdensServico = [
        {
          dataField: 'Id',
          dataType: 'string',
          caption: 'ID'
        },
        {
          dataField: 'DescricaoSolicitacao',
          dataType: 'string',
          caption: 'Descrição'
        },
        {
          dataField: 'DtHrCadastro',
          dataType: 'date',
          caption: 'Data de Cadastro'
        },
        {
          dataField: 'OrdemServicoTipo',
          dataType: 'string',
          caption: 'Tipo de O.S.'
        },
        {
          dataField: 'IdUltimoEstadoAndamento',
          caption: 'Estado do Andamento',
          lookup: {
              dataSource: this.listaEstadoAndamento,
              displayExpr: 'DescricaoEstadosAndamento',
              valueExpr: 'Id'
          }
        },
        {
          dataField: 'IdEquipe',
          caption: 'Equipe',
          lookup: {
              dataSource: this.listaEquipe,
              displayExpr: 'DescricaoEquipe',
              valueExpr: 'Id'
          }
        }
      ];

      // this.loadingVisible = false;

      return true;
    } else {
      return false;
    }
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  onEditingStart(e) {
    this.router.navigate([`/ordem-servico/${e.data.Id}`]);
  }

  onInitNewRow(e) {
    this.router.navigate(['/ordem-servico']);
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();
  }

  onContextMenuPreparing(e) {
    if (e.row && e.row.rowType === 'data') {
      console.log(e.row.data);
      const thisAux = this;

      e.items = [{
        text: 'Distribuir O.S.',
        onItemClick: this.distribuirOS.bind(this, e)
      }];

    }
  }

  distribuirOS(e) {
    this.distribuirOSForm.Id = e.row.data.Id;
    this.distribuirOSForm.DescricaoSolicitacao = e.row.data.DescricaoSolicitacao;
    if ((e.row.data.IdEquipe !== undefined) && (e.row.data.IdEquipe !== null) && (e.row.data.IdEquipe !== '')) {
      this.distribuirOSForm.IdEquipe = e.row.data.IdEquipe;
    }

    this.itemsDistribuirOSForm = [
      {
        dataField: 'Id',
        editorType: 'dxTextBox',
        label: { text: 'ID O.S.' },
        editorOptions: { disabled: true }
      },
      {
        dataField: 'DescricaoSolicitacao',
        editorType: 'dxTextBox',
        label: { text: 'Descrição da Solicitação' },
        editorOptions: { disabled: true }
      },
      {
        dataField: 'IdEquipe',
        editorType: 'dxSelectBox',
        label: { text: 'Equipe' },
        editorOptions: { items: this.listaEquipe, displayExpr: 'DescricaoEquipe', valueExpr: 'Id' },
        validationRules: [{
          type: 'required',
          message: 'Equipe é obrigatório.'
        }]
      }
    ];

    this.popupVisible = true;
  }

  gravarEquipeOS(e) {
    this.OSAux = new OrdemServico;
    const result = e.validationGroup.validate();

    if (result.isValid) {

      // Carrega o obj OS para adicionar a IdEquipee gravar
      this.ordemServicoService.getOrdemServicoById(this.distribuirOSForm.Id.toString()).subscribe(os => {

        // Faz o merge caso o objeto retornado do servidor seja diferente do objeto criado pela aplicacao
        const OSAuxMerge = Object.assign(this.OSAux, os);
        this.OSAux = OSAuxMerge;

        // Alimenta objeto com o valor da IdEquipe
        this.OSAux.IdEquipe = this.distribuirOSForm.IdEquipe;

        // Grava a O.S.
        this.ordemServicoService.gravarOrdemServico(this.OSAux).subscribe((ret: OrdemServico) => {
          notify(`Distribuição da Ordem de serviço gravado com sucesso! ${ret.Id}`, 'success', 2000);

          // Limpa dados de variaveis auxiliares
          this.distribuirOSForm = {Id: null, DescricaoSolicitacao: null, IdEquipe: null};
          this.OSAux = null;
          this.popupVisible = false;

          // Atualiza dados da Grid
          this.refreshDataGrid();
        },
        error => {
          notify('Erro ao gravar distribuição da Ordem de serviço!', 'error', 2000);
        });

      },
      error => {
        notify('Erro ao carregar Ordem de serviço!', 'error', 2000);
      });

    }

  }

}



// WEBPACK FOOTER //
// ./src/app/ordens-servico/ordens-servico.component.ts